import { render } from "./DashboardCard.vue?vue&type=template&id=51b4e73b"
const script = {}

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__